/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { createContext, useEffect, useReducer, useContext } from 'react'
import { Link, useHistory } from 'react-router-dom'
import jwtDecode from 'jwt-decode'
import { useTranslation } from 'react-i18next'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { ACCOUNT_INITIALISE, LOGIN, LOGOUT } from '../store/actions'
import accountReducer from '../store/accountReducer'
import axiosServices from '../utils/axios'
import { postDataService, getDataService } from '../services/back-end-service'
import {
  emptyLocalStorage,
  getLocalStorage,
  setLocalStorage,
  emptySessionStorage,
  removeLocalStorage,
} from '../utils/localStorage'
import { ACCESS_TOKEN, REFRESH_TOKEN, SCOPE_MODE } from '../utils/constants'
// import { CONFIG } from '../config/constant'
import { isBo, onError, onErrorTxt } from '../utils/CommonMethods'
import Spinner from '../components/Loader/Spinner'
import { url } from '../services/path-url'
import newOcLogo from '../assets/images/cpi-logo.png'
import newBg from '../assets/images/bg-images/new-bg-25.jpg'
import { TotpInput } from '../components/TotpInput'
import { BoUrl } from '../services/BO-path-url'
import { WebSocketContext } from './WebSocketContext'
// import { CONFIG } from '../config/constant'

// const onSuccessRefresh = (response) => {
//   console.log('onSuccessRefresh', response)
//   setLocalStorage(ACCESS_TOKEN, response.accesstoken)
//   setLocalStorage(REFRESH_TOKEN, response.refreshtoken)
// }
// const refreshTokenRequest = async () => {
//   const params = { refreshtoken: getLocalStorage(REFRESH_TOKEN) }
//   await postDataService(params, url.auth.refresh, onSuccessRefresh, onError)
// }

// let refreshTokenInterval = null

const initialState = {
  isLoggedIn: false,
  isInitialised: false,
  isOtp: false,
  user: null,
  menu: [],
  admin: [],
  entity: [],
  scope: [],
  client_access: {},
}

const JWTContext = createContext({
  ...initialState,
  login: () => Promise.resolve(),
  oidc_login: () => Promise.resolve(),
  oidc_Bo_login: () => Promise.resolve(),
  logout: () => {},
  change_perimetre: () => Promise.resolve(),
})

export function JWTProvider({ children }) {
  const [state, dispatch] = useReducer(accountReducer, initialState)
  const websocket = useContext(WebSocketContext)
  const { t, i18n } = useTranslation()
  const history = useHistory()
  // eslint-disable-next-line no-unused-vars
  const { instance } = useMsal()

  const isAuthenticated = useIsAuthenticated()

  const onSuccessMenu = async (data, isBo = false) => {
    const menu = data
    setLocalStorage('menu', JSON.stringify(menu.items))
    if (menu.video) {
      setLocalStorage('video_help', JSON.stringify(menu.video))
    }
    setLocalStorage('AdminMenu', JSON.stringify(menu.admin))
    setLocalStorage('entity', JSON.stringify(menu.entity))
    setLocalStorage('scope', JSON.stringify(menu.scope))
    setLocalStorage('entity_scope_table', JSON.stringify(menu.entity_scope))
    setLocalStorage(
      'clientAccess',
      isBo ? JSON.stringify(menu.client_access) : {}
    )
    if (menu.column_settings) {
      setLocalStorage(
        'preference',
        JSON.stringify(menu.column_settings || '[]')
      )
      removeLocalStorage('configColumn')
    }

    if (menu.block_column_settings) {
      setLocalStorage(
        'blockColumnSettings',
        JSON.stringify(menu.block_column_settings || '[]')
      )
    }

    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        isInitialised: true,
        menu: menu.items,
        admin: menu.admin,
        entity: menu.entity,
        scope: menu.scope,
        client_access: menu?.client_access || {},
      },
    })
    if (isBo) {
      history.replace('/bo/dashboard')
      return
    }
    const redirectUrl = data?.expired_password ? '/myaccount' : '/dashboard'
    history.replace(redirectUrl, {
      active_page: 2,
    })
    websocket().send(
      `{"type":"authentification","token":"${getLocalStorage(ACCESS_TOKEN)}"}`
    )
  }

  const onFailure = (err) => {
    dispatch({
      type: ACCOUNT_INITIALISE,
      payload: {
        isLoggedIn: false,
        user: null,
      },
    })
    onError(err)
  }

  const onSuccessAuth = (response, isBo = false) => {
    isBo
      ? setLocalStorage('ACCESS_TOKEN_BO', response.data.accesstoken)
      : setLocalStorage(ACCESS_TOKEN, response.data.accesstoken)
    if (response?.data?.totp === true) {
      dispatch({
        type: LOGIN,
        payload: {
          isLoggedIn: false,
          isInitialised: false,
          isOtp: true,
        },
      })
      return
    }
    setLocalStorage(REFRESH_TOKEN, response.data.refreshtoken)
    setLocalStorage('profile', JSON.stringify(response?.data?.picture))
    setLocalStorage('timezone', response?.data?.time_zone)
    setLocalStorage('logo', response.data.logo)

    const decodedToken = jwtDecode(response?.data?.accesstoken)

    setLocalStorage('LANGUAGE', decodedToken?.language)
    i18n.changeLanguage(decodedToken?.language)

    setLocalStorage('username', decodedToken?.name)
    setLocalStorage('user_id', decodedToken?.iduser)
    setLocalStorage('appname', decodedToken?.iss)
    setLocalStorage('customername', decodedToken?.customer)
    setLocalStorage('entity_scope', decodedToken?.entity_scope_name)
    setLocalStorage('entity_id', decodedToken?.idfiliale)

    setLocalStorage(SCOPE_MODE, 0)

    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        isInitialised: true,
        menu: [],
        admin: [],
        entity: [],
        scope: [],
        client_access: {},
      },
    })
    const urlMenu = isBo ? BoUrl.menu : url.user.menu
    const expired_password = response?.data?.expired_password

    getDataService(
      urlMenu,
      (data) => onSuccessMenu({ ...data, expired_password }, isBo),
      onFailure
    )
  }

  const onErrorAuth = (err) => {
    onError(err)
    setTimeout(() => {}, 1500)
  }
  const onErrorAuthOtp = (token) => {
    onErrorTxt('Invalid code')
    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: false,
        isInitialised: false,
        isOtp: true,
      },
    })
    setLocalStorage(ACCESS_TOKEN, token)
  }

  const login = async (username, password, lng, cb) => {
    const params = { username, password, encodedpassword: '', language: lng }
    try {
      const urlService = isBo() ? BoUrl.signin : url.auth.signin
      const response = await axiosServices.post(urlService, params, {
        'Content-Type': 'application/json',
      })
      if (cb) {
        cb(response)
      }
      if (response && response.data) {
        onSuccessAuth(response)

        return response.data
      }
    } catch (err) {
      onErrorAuth(err)
      if (cb) {
        cb(err)
      }
    }
  }

  const change_perimetre = (entity_id, scope_id) => {
    const onSuccessChange = async (data) => {
      emptyLocalStorage(true)
      emptySessionStorage()
      setLocalStorage(ACCESS_TOKEN, data.accesstoken)
      setLocalStorage(REFRESH_TOKEN, data.refreshtoken)
      if (websocket && websocket()) {
        websocket().send(
          `{"type":"authentification","token":"${data.accesstoken}"}`
        )
      }
      const decodedToken = jwtDecode(data.accesstoken)

      setLocalStorage('LANGUAGE', decodedToken.language)
      i18n.changeLanguage(decodedToken.language)

      setLocalStorage('username', decodedToken.name)
      setLocalStorage('appname', decodedToken.iss)
      setLocalStorage('customername', decodedToken.customer)
      setLocalStorage('entity_scope', decodedToken.entity_scope_name)
      setLocalStorage('idPerimetre', decodedToken.idperimetre)

      scope_id ? setLocalStorage(SCOPE_MODE, 1) : setLocalStorage(SCOPE_MODE, 0)
      dispatch({
        type: ACCOUNT_INITIALISE,
        payload: {
          isLoggedIn: true,
          menu: [],
          admin: [],
          entity: [],
          scope: [],
          client_access: {},
        },
      })
      getDataService(url.user.menu, onSuccessMenu, onFailure)
    }
    const executeChange = async () => {
      const params = { entity_id, scope_id }
      await postDataService(params, url.auth.switch, onSuccessChange, onFailure)
    }
    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        isInitialised: false,
        menu: [],
        admin: [],
        entity: [],
        scope: [],
      },
    })

    executeChange()
  }

  const oidc_Bo_login = async (accessToken) => {
    try {
      const response = await axiosServices.get(BoUrl.oidc, accessToken)
      if (response.data) onSuccessAuth(response, true)
      dispatch({
        type: LOGIN,
        payload: {
          isLoggedIn: true,
          isInitialised: false,
          menu: [],
          admin: [],
          entity: [],
          scope: [],
        },
      })
      return response.data
    } catch (err) {
      onErrorAuth(err)
    }
  }

  const oidc_login = async (type, accessToken) => {
    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        isInitialised: false,
        menu: [],
        admin: [],
        entity: [],
        scope: [],
      },
    })
    try {
      const response = await axiosServices.get(
        type === 1 ? url.auth.oidc : url.auth.okta,
        accessToken
      )
      if (response.data) onSuccessAuth(response)
      return response.data
    } catch (err) {
      onErrorAuth(err)
    }
  }

  const sendOtp = async (code) => {
    dispatch({
      type: LOGIN,
      payload: {
        isLoggedIn: true,
        isInitialised: false,
        isOtp: false,
        menu: [],
        admin: [],
        entity: [],
        scope: [],
      },
    })
    const tk = getLocalStorage(ACCESS_TOKEN)
    try {
      const response = await axiosServices.get(`${url.auth.totp}/${code}`, tk)
      if (response.data) onSuccessAuth(response)
      return response.data
    } catch (err) {
      onErrorAuthOtp(tk)
    }
  }

  // Redirect the other tabs to login page on logout
  useEffect(() => {
    const handleStorageEvent = (event) => {
      if (event.key === 'logout') {
        // Handle the logout event here
        dispatch({ type: LOGOUT })
        emptyLocalStorage()
        emptySessionStorage()
        // clearInterval(refreshTokenInterval);
      }
    }
    window.addEventListener('storage', handleStorageEvent)
    return () => {
      window.removeEventListener('storage', handleStorageEvent)
    }
  }, [])

  const logout = async () => {
    const isSupAdmin =
      window.localStorage.getItem('super_admin') == 'super_admin'
    localStorage.setItem('logout', Date.now().toString())

    dispatch({ type: LOGOUT })
    emptyLocalStorage()
    emptySessionStorage()
    dispatch({
      type: ACCOUNT_INITIALISE,
      payload: {
        isLoggedIn: false,
        user: null,
      },
    })

    if (isAuthenticated) {
      instance.logoutRedirect({
        postLogoutRedirectUri:
          isBo() || isSupAdmin ? '/bo/auth/signin' : '/auth/signin',
      })
    }
  }

  useEffect(() => {
    const init = async () => {
      try {
        const serviceToken = isBo()
          ? getLocalStorage('ACCESS_TOKEN_BO')
          : getLocalStorage(ACCESS_TOKEN)
        if (serviceToken) {
          const menu = JSON.parse(getLocalStorage('menu'))
          const admin = JSON.parse(getLocalStorage('AdminMenu'))
          const entity = JSON.parse(getLocalStorage('entity'))
          const scope = JSON.parse(getLocalStorage('scope'))
          const entity_scope_table = JSON.parse(
            getLocalStorage('entity_scope_table')
          )
          const client_access = isBo()
            ? JSON.parse(getLocalStorage('clientAccess'))
            : {}

          if (entity === null) {
            setLocalStorage('entity', JSON.stringify(menu.data.entity))
          }
          if (scope === null) {
            setLocalStorage('scope', JSON.stringify(menu.data.scope))
          }
          if (entity_scope_table === null) {
            setLocalStorage(
              'entity_scope_table',
              JSON.stringify(menu.entity_scope)
            )
          }

          const isMenuCharged = menu !== null
          if (!isMenuCharged) {
            await getDataService(url.user.menu, onSuccessMenu)
          }
          const { user } = serviceToken
          dispatch({
            type: ACCOUNT_INITIALISE,
            payload: {
              isLoggedIn: true,
              user,
              menu,
              admin,
              entity,
              scope,
              client_access,
            },
          })
        } else {
          dispatch({
            type: ACCOUNT_INITIALISE,
            payload: {
              isLoggedIn: false,
              user: null,
            },
          })
        }
      } catch (err) {
        dispatch({
          type: ACCOUNT_INITIALISE,
          payload: {
            isLoggedIn: false,
            user: null,
          },
        })
      }
    }
    init()
  }, [])

  const resetLogin = () => {
    dispatch({
      type: ACCOUNT_INITIALISE,
      payload: {
        isLoggedIn: false,
        user: null,
      },
    })
  }

  if (!state.isInitialised) {
    if (state.isOtp) {
      return (
        <div
          className="auth-wrapper aut-bg-img-side container-fluid d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${newBg})`,
            backgroundSize: 'cover',
            backgroundAttachment: 'fixed',
            backgroundPosition: 'center',
            height: '100vh',
            overflow: 'hidden',
          }}
        >
          <div className="auth-content text-center">
            <div style={{ marginBottom: '50px' }}>
              <img src={newOcLogo} alt="logo" width={360} />
            </div>
            <h3 className="mb-4">{t('login.login')}</h3>
            <TotpInput trigger={sendOtp} />
            <p className="mt-3 text-muted">
              {t('login.back_to')}{' '}
              <Link to="/auth/sigin" onClick={resetLogin}>
                {t('Login')}
              </Link>
            </p>
          </div>
        </div>
      )
    }
    return <Spinner />
  }

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <JWTContext.Provider
      value={{
        ...state,
        dispatch,
        login,
        logout,
        change_perimetre,
        oidc_login,
        oidc_Bo_login,
      }}
    >
      {children}
    </JWTContext.Provider>
  )
}

export default JWTContext

